import { useOrderCancellationQuery } from '../queries/useOrderCancellationQuery'

export const useCancellationOffers = (orderId: string) => {
  const { orderCancellationQuery, invalidateOrderCancellationQuery } = useOrderCancellationQuery([
    orderId,
  ])

  return {
    cancellableOffers:
      orderCancellationQuery.data?.cancellableItems.map(
        (cancellableItem) => cancellableItem.offerVariant,
      ) || [],
    nonCancellableOffers:
      orderCancellationQuery.data?.nonCancellableItems.map((nonCancellableItem) => ({
        ...nonCancellableItem.offerVariant,
        quantity: nonCancellableItem.quantity,
        nonCancellableReason: nonCancellableItem.reason,
      })) || [],
    partiallyCancellable: !!orderCancellationQuery.data?.partiallyCancellable,
    fullyCancellable: !!orderCancellationQuery.data?.fullyCancellable,
    orderCancellationQuery,
    invalidateOrderCancellationQuery,
  }
}
